var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.8478 13.6654C18.8234 11.025 21.0652 9.7404 21.1677 9.68059C19.8981 7.87581 17.9302 7.62922 17.2387 7.60956C15.5859 7.43998 13.9828 8.5738 13.1408 8.5738C12.2821 8.5738 10.9856 7.62595 9.5883 7.6538C7.79018 7.68084 6.10802 8.69587 5.18543 10.2721C3.28144 13.4859 4.70145 18.2088 6.52562 20.8066C7.43812 22.0789 8.50439 23.4995 9.90003 23.4495C11.2654 23.3946 11.7754 22.6008 13.4232 22.6008C15.0558 22.6008 15.5347 23.4495 16.9581 23.4175C18.4234 23.3946 19.346 22.1395 20.2266 20.8558C21.2811 19.3976 21.7046 17.9614 21.7214 17.8877C21.6869 17.8762 18.8755 16.8301 18.8478 13.6654Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.159 5.90064C16.8934 5.00521 17.3958 3.78701 17.2563 2.55078C16.1934 2.59666 14.8642 3.26761 14.0987 4.14338C13.4215 4.9151 12.8165 6.18 12.9728 7.36953C14.1668 7.45637 15.3927 6.78214 16.159 5.90064Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.71cb56d409751ef17abf8131e29da46b.svg";
export { ForwardRef as ReactComponent };